<div class="tags-container {{ isMultilevel ? 'multilevel' : 'single' }}">
    <ng-content></ng-content>
</div>
